const handleResponseOperation = () => {
  // STUB - seems easier to just inline for now
};

export default handleResponseOperation;
